import { DatePicker } from "antd";
import "../../../assets/scss/components/track-overlay.scss";
import "../../../assets/scss/components/modal.scss";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { ReleaseState } from "@type/models/store";
interface SelectedDates {
  rel_date?: string;
  preorder_date?: string;
  exclusive_release_date?: string;
}

interface Props {
  handleSubmission: (field: string, data: SelectedDates) => void;
  callFunction: boolean;
  localStorageCleared: boolean;
  clearForm: boolean;
}

let initialDate = {
  rel_date: undefined,
  preorder_date: undefined,
  exclusive_release_date: undefined,
};

const loadFormDataFromLocalStorage = () => {
  const savedData = localStorage.getItem("releasedate");
  return savedData ? JSON.parse(savedData) : initialDate;
};

const ReleaseDate: React.FC<Props> = ({
  handleSubmission,
  callFunction,
  localStorageCleared,
  clearForm,
}) => {
  const [selectedDates, setSelectedDates] =
    useState<SelectedDates>(initialDate);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const { releaseDate } = useSelector(
    (state: ReleaseState) => state.releaseInfo.releaseInfo
  );
  const handleSubmit = () => {
    const validationErrors: Record<string, string> = {};

    if (!selectedDates.rel_date) {
      validationErrors.rel_date = "Release date cannot be empty.";
    }

    saveFormDataToLocalStorage();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      if (handleSubmission) {
        handleSubmission("releaseDate", selectedDates);
      }
    }
  };

  useEffect(() => {
    if (callFunction) {
      handleSubmission("releaseDate", selectedDates);
      handleSubmit();
    }
  }, [callFunction]);

  const saveFormDataToLocalStorage = () => {
    localStorage.setItem("releasedate", JSON.stringify(selectedDates));
  };

  useEffect(() => {
    setErrors({});
    setSelectedDates(initialDate);
  }, [clearForm]);

  useEffect(() => {
    const savedFormData = loadFormDataFromLocalStorage();
    setSelectedDates(savedFormData);
  }, [localStorageCleared]);

  useEffect(() => {
    setSelectedDates((prevErrors: any) => ({
      ...prevErrors,
      ...releaseDate,
    }));
  }, [releaseDate]);

  return (
    <div className="track-overlay-wrapper  page page-label min-h-80">
      <div className=" container-fluid p-5 flex justify-content-center">
        <div className="col-12 col-xl-4">
          <div className="flex justify-content-center items-center tw-gap-[20px] tw-my-[20px] tw-flex-wrap">
            <div className="w-100 fields-wrapper flex-grow-shrink">
              <label className="text-left">Choose a main release date *</label>
              <DatePicker
                className="w-100 remove-input-border px-1 py-0"
                value={
                  selectedDates.rel_date
                    ? dayjs(selectedDates.rel_date)
                    : dayjs()
                }
                onChange={(date, dateString) =>
                  setSelectedDates({
                    ...selectedDates,
                    rel_date: dateString,
                  })
                }
              />
              {errors.rel_date && !selectedDates.rel_date && (
                <div className="text-danger">{errors.rel_date}</div>
              )}
            </div>
            <div className="w-100 fields-wrapper flex-grow-shrink">
              <label>Add a preorder date </label>
              <DatePicker
                className="w-100 remove-input-border px-1 py-0"
                value={
                  selectedDates.preorder_date
                    ? dayjs(selectedDates.preorder_date)
                    : undefined
                }
                onChange={(date, dateString) =>
                  setSelectedDates({
                    ...selectedDates,
                    preorder_date: dateString,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-4">
          <div className="w-100 flex justify-content-left items-left tw-gap-[20px] tw-my-[20px] tw-flex-wrap">
            <div className="w-100 fields-wrapper flex-grow-shrink">
              <label>Add an exclusive date </label>
              <DatePicker
                className="w-100 remove-input-border px-1 py-0"
                value={
                  selectedDates.exclusive_release_date
                    ? dayjs(selectedDates.exclusive_release_date)
                    : undefined
                }
                onChange={(date, dateString) =>
                  setSelectedDates({
                    ...selectedDates,
                    exclusive_release_date: dateString,
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseDate;
